import routes from '@routes/config';

export default [{
    path: routes.bill.index,
    name: routes.bill.index,
    component: () => import(/* webpackChunkName: "Bill" */  '@components/Bill/Index')
}]
            